export default [
  'In Uniform',
  'Post Military Life'
]
